import React from 'react';

const shimmer = `
  @keyframes shimmer {
    0% { background-position: -400px 0; }
    100% { background-position: 400px 0; }
  }
`;

const skeletonStyle = {
  background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
  backgroundSize: '800px 100%',
  animation: 'shimmer 1.5s infinite',
  borderRadius: 8,
};

export function SkeletonBox({ width = '100%', height = 16, style = {} }) {
  return (
    <>
      <style>{shimmer}</style>
      <div style={{ ...skeletonStyle, width, height, ...style }} />
    </>
  );
}

export function SkeletonCard() {
  return (
    <div className="card" style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ flex: 1 }}>
          <SkeletonBox height={12} width={80} style={{ marginBottom: 10 }} />
          <SkeletonBox height={32} width={60} style={{ marginBottom: 6 }} />
          <SkeletonBox height={12} width={120} />
        </div>
        <SkeletonBox width={52} height={52} style={{ borderRadius: 14 }} />
      </div>
    </div>
  );
}

export function SkeletonRow() {
  return (
    <tr>
      {[40, 120, 80, 200, 140, 140, 100].map((w, i) => (
        <td key={i} style={{ padding: '14px 16px' }}>
          <SkeletonBox height={14} width={w} />
        </td>
      ))}
    </tr>
  );
}

export function SkeletonAgendaItem() {
  return (
    <div style={{ padding: '16px 0', borderBottom: '1px solid var(--gray-100)' }}>
      <SkeletonBox height={12} width={100} style={{ marginBottom: 8 }} />
      <SkeletonBox height={16} width={180} style={{ marginBottom: 6 }} />
      <SkeletonBox height={12} width={120} />
    </div>
  );
}
